import store from '@/store';

; (function (win, lib) {
    var doc = win.document;
    var docEl = doc.documentElement;
    var metaEl = doc.querySelector('meta[name="viewport"]');
    var flexibleEl = doc.querySelector('meta[name="flexible"]');
    var dpr = 0;
    var scale = 0;
    var tid;
    var flexible = lib.flexible || (lib.flexible = {});

    if (metaEl) {
        console.warn('将根据已有的meta标签来设置缩放比例');
        var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
        if (match) {
            scale = parseFloat(match[1]);
            dpr = parseInt(1 / scale);
        }
    } else if (flexibleEl) {
        var content = flexibleEl.getAttribute('content');
        if (content) {
            var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
            var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
            if (initialDpr) {
                dpr = parseFloat(initialDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
            if (maximumDpr) {
                dpr = parseFloat(maximumDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
        }
    }

    if (!dpr && !scale) {
        var isAndroid = win.navigator.appVersion.match(/android/gi);
        var isIPhone = win.navigator.appVersion.match(/iphone/gi);
        var devicePixelRatio = win.devicePixelRatio;
        if (isIPhone) {
            // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
            if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
                dpr = 3;
            } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
                dpr = 2;
            } else {
                dpr = 1;
            }
        } else {
            // 其他设备下，仍旧使用1倍的方案
            dpr = 1;
        }
        scale = 1 / dpr;
    }

    docEl.setAttribute('data-dpr', dpr);
    if (!metaEl) {
        metaEl = doc.createElement('meta');
        metaEl.setAttribute('name', 'viewport');
        metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no');
        if (docEl.firstElementChild) {
            docEl.firstElementChild.appendChild(metaEl);
        } else {
            var wrap = doc.createElement('div');
            wrap.appendChild(metaEl);
            doc.write(wrap.innerHTML);
        }
    }

    function refreshRem() {
        var width = docEl.getBoundingClientRect().width;
        var height = docEl.getBoundingClientRect().height;
        // var width = window.screen.width;
        // var height = window.screen.height;

        // PC尺寸
        // if (width / dpr > 1600) {
        //     width = 1600 * dpr;
        // }
        // 笔记本
        // if (width / dpr < 1366 && width / dpr > 1024) {
        //     width = 1366 * dpr;
        // }
        // iPad
        // if (width / dpr < 1024) {
        //     width = 1024 * dpr;
        // }

        let max = width > height ? width : height
        let min = !(width > height) ? width : height
        // console.log("max===", max, min, width, height)

        let rem = ''
        if (max == width) {
            let pixo = max / 1600 * 1057
            let thePoint = min / pixo
            rem = max / 10 * thePoint;
        } else {
            let pixo = min / 1057 * 1600
            let thePoint = max / pixo
            rem = max / 10 * thePoint;
        }
        let equipmentType = getOS();
        console.log(equipmentType);
        if(equipmentType == 'Mac'){
            rem = 150;
        } else {
            rem = 120;
        }
        
        // console.log("height===", height)
        // console.log("width===", width)
        // console.log(' ---- rem -----', rem)
        // rem = width / 10;
        store.dispatch("setRem", rem);

        docEl.style.fontSize = rem + 'px';
        flexible.rem = win.rem = rem;
    }

    function getOS() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
        // Windows
        if (/Windows NT 10.0/.test(userAgent) || /Windows NT 6.3/.test(userAgent) || /Windows NT 6.2/.test(userAgent) || /Windows NT 6.1/.test(userAgent) || /Windows NT 6.0/.test(userAgent) || /Windows ME/.test(userAgent) || /Windows 98/.test(userAgent) || /Windows 95/.test(userAgent) || /Windows CE/.test(userAgent) || /Win32/.test(userAgent) || /Win64/.test(userAgent)) {
            return 'Windows';
        }
        // macOS
        else if (/Mac OS X/.test(userAgent)) {
            return 'Mac';
        }
        // Linux
        else if (/Linux/.test(userAgent)) {
            return 'Linux';
        }
        // Mobile
        else if (/Android/.test(userAgent)) {
            return 'Android';
        }
        else if (/iPhone/.test(userAgent) || /iPad/.test(userAgent)) {
            return 'iOS';
        }
        // Other
        else {
            return 'Other';
        }
    }
    
    console.log(getOS()); // 输出操作系统
    

    win.addEventListener('resize', function () {
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
    }, false);
    win.addEventListener('pageshow', function (e) {
        if (e.persisted) {
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
        }
    }, false);

    if (doc.readyState === 'complete') {
        doc.body.style.fontSize = 12 * dpr + 'px';
    } else {
        doc.addEventListener('DOMContentLoaded', function (e) {
            doc.body.style.fontSize = 12 * dpr + 'px';
        }, false);
    }


    refreshRem();

    flexible.dpr = win.dpr = dpr;
    flexible.refreshRem = refreshRem;
    flexible.rem2px = function (d) {
        var val = parseFloat(d) * this.rem;
        if (typeof d === 'string' && d.match(/rem$/)) {
            val += 'px';
        }
        return val;
    }
    flexible.px2rem = function (d) {
        var val = parseFloat(d) / this.rem;
        if (typeof d === 'string' && d.match(/px$/)) {
            val += 'rem';
        }
        return val;
    }

})(window, window['lib'] || (window['lib'] = {}));



// WEBPACK FOOTER //
// ./src/utils/flexible.js